var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858282",
    d: "M2.23333 2.17702C3.19999 1.21035 4.52666 0.610352 5.99999 0.610352C8.94666 0.610352 11.3267 2.99702 11.3267 5.94368C11.3267 8.89035 8.94666 11.277 5.99999 11.277C3.51333 11.277 1.43999 9.57702 0.846661 7.27702H2.23333C2.77999 8.83035 4.25999 9.94368 5.99999 9.94368C8.20666 9.94368 9.99999 8.15035 9.99999 5.94368C9.99999 3.73702 8.20666 1.94368 5.99999 1.94368C4.89333 1.94368 3.90666 2.40368 3.18666 3.13035L5.33333 5.27702H0.66666V0.610352L2.23333 2.17702Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.b6229c9e77644b7a05cff532ece99b86.svg";
export { ForwardRef as ReactComponent };